__turbopack_context__.v({
  "button": "Button-module-scss-module__xxUg6a__button",
  "color": "Button-module-scss-module__xxUg6a__color",
  "fullWidth": "Button-module-scss-module__xxUg6a__fullWidth",
  "m": "Button-module-scss-module__xxUg6a__m",
  "secondary": "Button-module-scss-module__xxUg6a__secondary",
  "tertiary": "Button-module-scss-module__xxUg6a__tertiary",
});
